import { MenuItem } from '../../../data/models/menu-item.model';
import { RoleLike } from '../../../data/schemas/user.schema';

/**
 * Filtra el menú en 2 niveles: los hijos se evalúan individualmente y un grupo
 * solo se conserva si le queda al menos un hijo visible.
 */
export function filterMenu(items: readonly MenuItem[], canSee: (item: MenuItem) => boolean): MenuItem[] {
  return items.flatMap((item) => {
    if (item.children) {
      const children = item.children.filter(canSee);
      return children.length ? [{ ...item, children }] : [];
    }
    return canSee(item) ? [item] : [];
  });
}

/** Indica si `url` (sin barra inicial) es la ruta actual o un ancestro de ella. */
export function isUrlActive(url: string, currentUrl: string): boolean {
  const path = currentUrl.split(/[?#;]/)[0];
  return path === '/' + url || path.startsWith('/' + url + '/');
}

/** Texto a mostrar para un rol: su descripción si la tiene, si no su nombre. */
export function getRoleDescription(role: RoleLike): string {
  return typeof role === 'string' ? role : role.description || role.name;
}
